import { render, staticRenderFns } from "./equipmentItem.vue?vue&type=template&id=27d94540&scoped=true"
import script from "./equipmentItem.vue?vue&type=script&lang=js"
export * from "./equipmentItem.vue?vue&type=script&lang=js"
import style0 from "./equipmentItem.vue?vue&type=style&index=0&id=27d94540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d94540",
  null
  
)

export default component.exports